import { SVGProps } from "react";

const KpiCheckIcon = ({
  width = 20,
  height = 20,
  color = "#00852D",
  ...props
}: SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 18.3333 18.3333"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.16667 0C7.35367 0 5.58139 0.537616 4.07394 1.54486C2.56649 2.55211 1.39158 3.98374 0.697775 5.65873C0.00397176 7.33372 -0.177559 9.17683 0.176139 10.955C0.529837 12.7332 1.40288 14.3665 2.68486 15.6485C3.96684 16.9305 5.60018 17.8035 7.37834 18.1572C9.1565 18.5109 10.9996 18.3294 12.6746 17.6356C14.3496 16.9418 15.7812 15.7668 16.7885 14.2594C17.7957 12.7519 18.3333 10.9797 18.3333 9.16666C18.3333 7.96288 18.0962 6.77088 17.6356 5.65873C17.1749 4.54658 16.4997 3.53606 15.6485 2.68485C14.7973 1.83365 13.7867 1.15844 12.6746 0.697771C11.5624 0.237103 10.3705 0 9.16667 0ZM13.1267 8.25L8.855 12.5308C8.75522 12.6307 8.63655 12.7097 8.50593 12.7632C8.3753 12.8167 8.23533 12.8437 8.09417 12.8425C7.9544 12.8435 7.81586 12.8164 7.68675 12.7628C7.55764 12.7093 7.44058 12.6304 7.3425 12.5308L5.20667 10.3767C5.01527 10.1757 4.91003 9.90787 4.91341 9.63037C4.9168 9.35286 5.02854 9.08768 5.22478 8.89144C5.42102 8.6952 5.6862 8.58346 5.9637 8.58008C6.24121 8.57669 6.50904 8.68194 6.71 8.87333L8.09417 10.2483L11.6233 6.72833C11.7232 6.62962 11.8416 6.55156 11.9717 6.4986C12.1018 6.44564 12.241 6.41882 12.3815 6.41967C12.5219 6.42052 12.6608 6.44902 12.7903 6.50356C12.9197 6.55809 13.0371 6.63758 13.1358 6.7375C13.2345 6.83741 13.3126 6.95579 13.3656 7.08587C13.4185 7.21596 13.4454 7.3552 13.4445 7.49565C13.4436 7.63609 13.4151 7.775 13.3606 7.90443C13.3061 8.03386 13.2266 8.15129 13.1267 8.25Z"
      fill={color}
    />
  </svg>
);

export default KpiCheckIcon;
